//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CommonCard from "../CommonCard";
import DateSwitch from "../DateSwitch";
import Row from "../CommonRow";
import { mapState } from "vuex";

export default {
  components: { CommonCard, DateSwitch, Row },
  data() {
    return {
      data: [50, 30, 50, 30],
      active: 2,
      options: {},
    };
  },
  computed: {
    ...mapState(["dateList"]),
    filterData() {
      // 把最大的用100%展示，其他的依照最大的算百分比
      let list = this.data.map((v) => Math.abs(v));
      let max = Math.max(...list);
      if (max > 100) {
        return list.map((v) => (v / max) * 100 + "%");
      } else {
        return list.map((v) => (v / 100) * 100 + "%");
      }
    },
  },
  mounted() {
    let data = [334520, 122020, 722238];
    this.options = {
      tooltip: {},
      grid: {
        top: 0,
        bottom: 2,
        left: 80,
        right: 0,
      },
      xAxis: {
        type: "value",
        splitLine: {
          lineStyle: {
            color: "#E5E5E5",
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#E5E5E5",
          },
        },
        axisLabel: {
          show: false,
        },
      },
      yAxis: {
        type: "category",
        data: ["2019年", "2020年", "2021年"],
        axisLabel: {
          width: 75,
          overflow: "truncate",
          formatter: function (value, index) {
            return [`{a|${data[index]}}`, `{b|${value}}`].join("\n");
          },
          rich: {
            a: {
              fontSize: 17,
              color: "#DA302A",
            },
            b: {
              fontSize: 10,
              color: "#666666",
              padding: [4, 0, 0, 0],
            },
          },
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          lineStyle: {
            color: "#E5E5E5",
          },
        },
      },
      series: [
        {
          type: "bar",
          data,
          barWidth: "40%",
          itemStyle: {
            normal: {
              color: function (params) {
                const colorList = ["#FFCE7C", "#FFCE7C", "#DA302A"];
                return colorList[params.dataIndex];
              },
              barBorderRadius: [0, 14, 14, 0],
            },
            label: {
              show: true,
            },
          },
        },
      ],
    };
  },
};
